<template>
  <v-app>
    <div id="app">
      <Widget/>
    </div>
  </v-app>
</template>

<script>

import Widget from './components/Widget.vue'
import cfg from './api/config.js'

export default {
  name: 'App',
  components: {
    Widget
  },
  mounted() {
    document.documentElement.style.setProperty("--primaryColor", cfg.customer.primaryColor);
  }
}
</script>

<style lang="scss">

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size:14px;
  background-color: transparent;
  overflow-x: hidden; 
  overflow-y: hidden;
}
body, html { 
    overflow-x: hidden; 
    overflow-y: hidden;
}

html {

  --scrollbarBG: #f6f6f6;
  --thumbBG: #7b7b7b;
}
div ::-webkit-scrollbar {
  width: 8px;
}
div  {
  scrollbar-width: thin;
  scrollbar-color: var(--thumbBG) var(--scrollbarBG);
}
div ::-webkit-scrollbar-track {
  background: transparent;
}
div ::-webkit-scrollbar-thumb {
  background-color: #2c3e50 !important;
  border-radius: 6px;
  border: 3px solid var(--scrollbarBG);
}

</style>
